import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import useCustomerTypesRandomColor from '../../../../../../../utils/hooks/customer/useCustomerTypesRandomColor'
import { BuyTagModelType } from '@teinor/erp/types/company/order/buy/buyTag'


interface ModalCEBuyTagProps extends ModalEditComponentProps { }

const ModalCEBuyTag: React.FC<ModalCEBuyTagProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { getDefaultRandomColorCustomerTypes } = useCustomerTypesRandomColor()

    const fields: FormRender<BuyTagModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'color',
                    label: t('color', 'Color'),
                    component: 'InputColorWithMargin',
                    defaultValue: allRowData?.color || getDefaultRandomColorCustomerTypes()
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
            ],
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/order/buy/tag/updateBuyTag'} translations={{ title: t('editTag', 'Editar etiqueta'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/order/buy/tag/createBuyTag'} translations={{
        title: t('createTag', 'Crear etiqueta'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEBuyTag